import { MONO_FONT_FAMILY } from '@medcom/shared-ui/styles/globalCss.ts';
import { ConfigProvider } from 'antd';
import deDE from 'antd/es/locale/de_DE';
import type React from 'react';
import { type ReactNode, useEffect } from 'react';
import { useGetTheme } from './api/theme.queries.ts';
import { useGetUserInfo } from './api/user-info.queries.ts';
import { defaultTheme, useThemeStore } from './store/useThemeStore.ts';

export const DynamicConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { data: userInfo } = useGetUserInfo();
  const { data: accountTheme } = useGetTheme({
    id: userInfo?.themeId ?? '',
  });
  const { theme, setTheme, previewMode } = useThemeStore();

  useEffect(() => {
    if (!previewMode && theme.id !== accountTheme?.id) {
      setTheme(accountTheme ?? defaultTheme, false);
    }
  }, [accountTheme, theme, setTheme, previewMode]);

  return (
    <ConfigProvider
      locale={deDE}
      theme={{
        token: {
          colorLink: '#4A88CB',
          colorPrimary: theme.colorPrimary,
          fontFamily: 'Inter, sans-serif',
          fontFamilyCode: MONO_FONT_FAMILY,
          controlItemBgActive: theme.controlItemBgActive,
          controlItemBgActiveHover: theme.controlItemBgActiveHover,
        },
        components: {
          Layout: {
            headerBg: '#fff',
            bodyBg: '#fff',
            headerHeight: 80,
          },
          Menu: {
            itemBg: '#F8F7F4',
            subMenuItemBg: '#F8F7F4',
          },
          Table: {
            // antd's 8px runs content-sized columns together; the large size's 16px for every size
            cellPaddingInlineMD: 16,
            cellPaddingInlineSM: 16,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
